var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-xs-center sz-kath-title"},[_vm._v("Protokolle")]),_c('ProtokolleTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }